export default __webpack_public_path__ + "static/media/Snd_TryN.9bcdd1f1.mp3";